import "core-js/modules/es.array.push.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "pIndexHead",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "pIndexHead-main",
    style: {
      background: `url(${require(`@images/ui/${!_vm.isMobile ? 'index-head-bg' : 'index-head-bg-h5'}.jpg`)}) center top/auto 100% no-repeat`
    }
  }, [_c('div', {
    staticClass: "pIndexHead-con"
  }, [_c('div', {
    staticClass: "pIndexHead__sub"
  }, [_vm._v(_vm._s(_vm.$lang("Final Farming Season")))]), _c('div', {
    staticClass: "pIndexHead__title"
  }, [_vm._v(_vm._s(_vm.$lang("FAIR MEMES FOR FAIR FUN")))]), _c('div', {
    staticClass: "pIndexHead-btns"
  }, [_c('div', {
    staticClass: "pIndexHead-how btn",
    on: {
      "click": _vm.onHowWorksShow
    }
  }, [_vm._v(_vm._s(_vm.$lang("How it works")))]), _c('div', {
    staticClass: "pIndexHead-token btn",
    on: {
      "click": function ($event) {
        return _vm.$router.push('/launch');
      }
    }
  }, [_vm._v(_vm._s(_vm.$lang("Launch Token")))])])])])]);
};
var staticRenderFns = [];
export { render, staticRenderFns };